import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQAccordion() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-7 md:px-12" data-id="element-29" data-mp="26b0glju2gw3b">
      <h2 className="text-center text-2xl font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-3xl" data-id="element-30" data-mp="21h5ygku40p6c">
        Preguntas frecuentes
      </h2>
      <div className="mt-4 divide-y divide-slate-200 overflow-hidden rounded-md border border-slate-200 bg-white" data-id="element-31" data-mp="2aaizyb68oz41">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-32" data-mp="2k8yhpnjdmw0v" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left focus:outline-none focus-visible:bg-slate-50" data-id="element-33" data-mp="2k9qeh1opmzsq">
                <span className="text-sm font-bold leading-tight text-blue-950 md:text-base" data-id="element-34" data-mp="2zrw6ru0fspr0">{f.q}</span>
                <ChevronDownIcon className={`h-4 w-4 shrink-0 text-amber-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={3} aria-hidden data-id="element-35" data-mp="38udte9k07kej" />
              </button>
              <AnimatePresence initial={false} data-id="element-36" data-mp="3ijxab9o5p46r">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-37" data-mp="3nhyz8b89jxq5">
                    <p className="px-3 pb-3 text-sm leading-snug text-slate-600 md:text-base" data-id="element-38" data-mp="22706qm5ek96t">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}